export const ACTION = {
  DISABLE_FINANCING_LEAD: 'disable_financing_lead',
  ENABLE_FINANCING_LEAD: 'enable_financing_lead',
  FORM_HAS_CAPTCHA: 'form_has_captcha',
  FORM_HAS_CONTACT_ERROR: 'form_has_contact_error',
  SET_FIELDS_WITH_LAST_CONTACT_DETAILS: 'set_fields_with_last_contact_details',
  SET_FIELDS_WITH_USER_LOGGED_DATA: 'set_fields_with_user_logged_data',
  SET_IS_FORM_SUBMITTED: 'set_is_form_submitted',
  SET_IS_SELLER_BLOCKED: 'set_is_seller_blocked',
  UPDATE_FIELD_VALUE: 'update_field_value',
  UPDATE_FORM_ERRORS: 'update_form_errors',
  USER_HAS_CONTACTED: 'user_has_contacted',
  USER_HAS_SUBMITTED: 'user_has_submitted',
  USER_HAS_SUCCESSFUL_CAPTCHA: 'user_has_successful_captcha',
  SET_AUTH_BEFORE_LEAD_RESULT: 'set_auth_before_lead_result'
}
